import {useEffect, useState} from "react";
import {Navigate, useLocation} from "react-router-dom";

import {api} from "../../lib/api";

import {IDoctorData} from "../../providers/doctorsData/types";

import Footer from "../../components/Elements/Footer";
import {Header} from "../../components/Elements/Header";
import {ProfessionalCard} from "../../components/Cards/ProfessionalCard";
import {ProfessionalCardSkeleton} from "../../components/Skeletons/ProfessionalCardSkeleton";
import {usePartnerData} from "../../providers/partnerData";

const ProfissionalPage = () => {
  const {partnerUrl} = usePartnerData();
  const location = useLocation();
  const doctorId = location.state as IDoctorData;
  const [doctorData, setDoctorData] = useState<IDoctorData>({} as IDoctorData);

  useEffect(() => {
    const getDoctorData = async () => {
      try {
        const {data} = await api.get("/specialistdoctor/list", {
          params: {
            idSpecialistDoctor: doctorId,
          },
        });

        setDoctorData(data.specialistDoctors[0]);
      } catch (error) {
        console.error(error);
      }
    };

    getDoctorData();
  }, [doctorId]);

  if (!location.state) {
    return <Navigate to={`/${partnerUrl}`} />;
  }

  return (
    <>
      <Header />
      <div id="wrapper" className="p-0">
        <div className="page-header flex-fill justify-content-start text-body">
          <div className="shape"></div>
          <div className="container position-relative py-5">
            <h1 className="text-center text-white mb-1">
              Detalhes do Profissional
            </h1>
            <p className="text-center text-white mb-5">
              {doctorData.gender === 0 && "Dra."}
              {doctorData.gender === 1 && "Dr."} {doctorData.name}
            </p>

            {!!Object.keys(doctorData).length ? (
              <ProfessionalCard {...doctorData} />
            ) : (
              <ProfessionalCardSkeleton />
            )}

            {!!doctorData?.curriculum && (
              <>
                <div className="row divider">
                  <div className="col-10 p-3 p-lg-4 border-3 border-start border-end"></div>
                </div>

                <div className="card text-body mb-5">
                  <div className="row mx-0">
                    <div className="col-12 col-lg-auto bg-light py-4 py-lg-5 rounded-start px-3 px-md-5 text-center text-lg-start">
                      <i className="fs-1 las la-graduation-cap"></i>
                      <h2 className="fw-bold">
                        CURRICULUM
                        <span className="d-block fw-normal">VITAE</span>
                      </h2>
                    </div>
                    <div
                      className="col py-5 px-3 px-md-5 align-self-center"
                      style={{whiteSpace: "pre-wrap"}}
                    >
                      <p className="m-0">{doctorData?.curriculum}</p>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ProfissionalPage;
